import React, { useState, useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { useSelector } from 'react-redux';
import Grid from '@mui/material/Grid';
import FormInputDropdown from 'components/Common/Forms/FormInputDropDown';
import { showLoader, useNotification } from 'utils/commonUtils';
import { getUsersList } from 'layouts/users/services/userApis';
import { useDispatch } from 'react-redux';
import { setEmployees } from 'layouts/documentManagement/store/employeesSlice/employeesSlice';
import { setEmployee } from 'layouts/documentManagement/store/employeeSlice/employeeSlice';
import { useNavigate } from 'react-router-dom';
import { PCard } from 'components/Ui/styled';

const Employees = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { NotificationPopup, handleErrorResponse } = useNotification();
  const [isLoading, setIsLoading] = useState(false);
  const employees = useSelector((state) => state.employees);

  useEffect(() => {
    fetchEmployees();
  }, []);

  const fetchEmployees = async () => {
    try {
      setIsLoading(true);
      const employeeData = await getUsersList();
      dispatch(setEmployees(employeeData));
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      handleErrorResponse(error?.response?.data?.message);
    }
  };

  const defaultValue = {
    employeeName: '',
  };

  const useFunction = useForm({
    mode: 'onChange',
    defaultValues: defaultValue,
  });

  const { control, register, reset } = useFunction;

  useEffect(() => {
    reset(defaultValue);
  }, [defaultValue.employeeName]);

  const employeesData = employees?.map((item) => ({
    id: item?.username,
    value: item?.username,
  }));

  const handleEmployee = (e) => {
    dispatch(setEmployee(e.target.value));
    navigate("/document-management/employee-documents/details");
  };

  if (isLoading) {
    return showLoader();
  }

  return (
    <>
      <PCard>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6} md={12}>
            <FormInputDropdown
              name="employeeName"
              control={control}
              options={employeesData}
              label="Select User"
              register={register('employeeName', {
                onChange: (e) => {
                  handleEmployee(e);
                },
              })}
            />
          </Grid>
        </Grid>
      </PCard>
      <NotificationPopup />
    </>
  );
};

export default Employees;